export default __webpack_public_path__ + "static/media/Addition_00.118061bb.png";